define.alias("ember-composable-helpers/helpers/take", "preview-grid/helpers/take");